import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * @Author: xiaocheng.hua
 * @Date: 2022-03-14 16:58:06
 * @LastEditors: guorui.teng 704386484@qq.com
 * @LastEditTime: 2023-04-10 17:03:35
 * @FilePath: \kitchen-online-web\src\components\sizeData\components\stepOne.tsx
 */
import { useContext, useRef, useState, useEffect, } from 'react';
import { useTranslation } from 'react-i18next';
import squareI from '@/assets/squareI.svg';
import squareH from '@/assets/squareH.svg';
import squareL from '@/assets/squareL.svg';
import squareU from '@/assets/squareU.svg';
import squareNo from '@/assets/squareNo.svg';
import Loading from '@/components/Loading/loading';
import { GroupRectCheckbox } from '@/aid-base';
import { AppContext } from '@/redux/store';
import { defaultSize, cabinetShape, } from '@/utils/rules/const';
import ShapeChooseGuide from '@/components/shapeChooseGuide/shapeChooseGuide';
import lampBulbPng from '@/assets/lamp-bulb.png';
import gioTrack from '@/utils/track';
import { GIO } from '@/utils/gio';
import stepone from './stepOne.module.scss';
export default function StepOne() {
    const { initState, dispatch } = useContext(AppContext);
    const container = useRef(null);
    const { t } = useTranslation();
    const { typeI, typeH } = cabinetShape;
    const [showTips, setShowtips] = useState(true);
    const [showGuide, setShowGuide] = useState(false);
    useEffect(() => {
        dispatch({ type: 'isChangeApi', payload: false });
    }, []);
    const eventHandle = () => {
        if (showTips && !initState.is3DFirstInit) { // 此页面第一次显示，且下一步后也不显示
            dispatch({ type: 'isChangeTopTips', payload: true });
            setShowtips(false);
        }
    };
    // 柜型数组对象，作为组件GroupRectCheckbox参数
    const sizeList = [
        {
            key: 'I',
            name: t('size_data.shape_I'),
            icon: _jsx("img", { alt: "", src: squareI, style: { width: '62px' } }, void 0),
            shapeImg: squareI,
        }, {
            key: 'H',
            name: t('size_data.shape_H'),
            icon: _jsx("img", { alt: "", src: squareH, style: { width: '38px' } }, void 0),
            shapeImg: squareH,
        }, {
            key: 'L',
            name: t('size_data.shape_L'),
            icon: _jsx("img", { alt: "", src: squareL, style: { width: '48px' } }, void 0),
            shapeImg: squareL,
        }, {
            key: 'U',
            name: t('size_data.shape_U'),
            icon: _jsx("img", { alt: "", src: squareU, style: { width: '48px' } }, void 0),
            shapeImg: squareU,
        },
    ];
    // 顶柜选择框，根据底柜联动
    const topTypeList = (bottomType = 'L') => {
        const sizeTmpObj = {
            I: ['I'],
            L: ['I', 'L'],
            H: ['I', 'H'],
            U: ['I', 'H', 'L'],
        };
        return sizeList.filter((item) => sizeTmpObj[bottomType === 'U_S' ? 'U' : bottomType].includes(item.key));
    };
    // version2 底柜：无顶柜对象
    const noTopSizeList = [{
            id: 'N',
            name: t('size_data.no_need_for_top_cabinet'),
            icon: _jsx("img", { alt: "", src: squareNo, style: { width: '20px' } }, void 0),
            key: 'N',
        }];
    // 切换底柜类型
    const changUnder = (key) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        if (key === initState.sizeUnder.key)
            return;
        Loading.show();
        dispatch({ type: 'isChangeApi', payload: true }); // 修改时切换柜型，调用接口init/update
        dispatch({ type: 'isSeat', payload: 'R' }); // 顶柜位置左中右
        // 更改底柜柜型
        dispatch({ type: 'sizeUnderId', payload: { key } });
        // 切换底柜类型时 在切换到I型底柜 且 顶柜的类型为L型或H型的情况下需要重置顶柜类型为I型
        // 切换为L型时 顶柜如果为H型 就变成I型
        // 切换为H型时 顶柜如果为L型就变成 I型
        //
        // 或者说，切换底柜时，如果 原来有顶柜 且 原来的顶柜类型不在现在的顶柜类型list中，重置顶柜类型为I型
        // if ((key === typeI && (initState.sizeTop.key === 'L' || initState.sizeTop.key === 'H'))
        // || (initState.sizeTop.key === 'H' && (key === typeI || key === typeL))
        // || (key === typeH && initState.sizeTop.key === 'L')) {
        if (initState.hasTopCabinet && !topTypeList(key).find((item) => item.key === initState.sizeTop.key)) {
            dispatch({ type: 'sizeTopId', payload: { key: typeI } });
        }
        // 顶柜底柜长度都重置默认
        dispatch({
            type: 'setUnderLength',
            payload: [
                (_b = (_a = defaultSize[key]) === null || _a === void 0 ? void 0 : _a.bottom) === null || _b === void 0 ? void 0 : _b.len1,
                (_d = (_c = defaultSize[key]) === null || _c === void 0 ? void 0 : _c.bottom) === null || _d === void 0 ? void 0 : _d.len2,
                (_f = (_e = defaultSize[key]) === null || _e === void 0 ? void 0 : _e.bottom) === null || _f === void 0 ? void 0 : _f.len3,
            ],
        });
        dispatch({
            type: 'setTopLength',
            payload: [
                (_h = (_g = defaultSize[key]) === null || _g === void 0 ? void 0 : _g.top) === null || _h === void 0 ? void 0 : _h.len1,
                (_k = (_j = defaultSize[key]) === null || _j === void 0 ? void 0 : _j.top) === null || _k === void 0 ? void 0 : _k.len2,
                (_m = (_l = defaultSize[key]) === null || _l === void 0 ? void 0 : _l.top) === null || _m === void 0 ? void 0 : _m.len3,
            ],
        });
        // 重置水槽灶台位置
        dispatch({
            type: 'setLocation',
            payload: {
                sinkLocation: null,
                cookLocation: null, // 灶台位置
            },
        });
        GIO('clickData', {
            eventType_var: 'click',
            module_var: 'shape_choose',
            objectType_var: '底柜柜型',
            objectName_var: `${key}字形`,
        });
        // 底柜选择完成后，自动抬到顶柜
        setTimeout(() => {
            var _a;
            (_a = document.getElementById('step-one-container')) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                behavior: 'smooth',
                block: 'end',
                inline: 'nearest',
            });
            if (!initState.is3DFirstInit) {
                dispatch({ type: 'isChangeTopTips', payload: true });
            }
        }, 100);
    };
    // 切换顶柜类型
    const changeTop = (key) => {
        if (key === initState.sizeTop.key)
            return;
        Loading.show();
        dispatch({ type: 'isChangeApi', payload: true }); // 修改时切换柜型，调用接口init/update
        dispatch({ type: 'isSeat', payload: 'R' }); // 顶柜位置左中右
        // 更改顶柜柜型
        dispatch({ type: 'sizeTopId', payload: { key } });
        GIO('clickData', {
            eventType_var: 'click',
            module_var: 'shape_choose',
            objectType_var: '顶柜柜型',
            objectName_var: key === 'N' ? '无需顶柜' : `${key}字形`,
        });
        // 设置有无顶柜
        if (key === 'N') {
            dispatch({ type: 'setHasTopCabinet', payload: false });
        }
        else {
            dispatch({ type: 'setHasTopCabinet', payload: true });
        }
        // 顶柜长度跟随底柜
        if (key === typeH && initState.sizeUnder.key === 'U') {
            dispatch({
                type: 'setTopLength',
                payload: [238, undefined, 238],
            });
        }
        else {
            dispatch({
                type: 'setTopLength',
                payload: initState.lengthVal,
            });
        }
    };
    const openGuide = () => {
        gioTrack('clickData', {
            eventType_var: 'click',
            platform_var: localStorage.getItem('gioPlatform'),
            pageId_var: window.location.href,
            module_var: 'cabinet_guide',
            objectType_var: 'guide',
            objectName_var: '什么柜型适合我家？',
        });
        setShowGuide(true);
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: stepone.container, id: "step-one-container", ref: container }, { children: _jsxs("div", Object.assign({ className: stepone.content, onTouchEnd: () => eventHandle() }, { children: [_jsx("div", Object.assign({ className: stepone.title }, { children: t('size_data.shape_choose') }), void 0),
                        _jsxs("div", Object.assign({ className: stepone['guide-container'], onTouchEnd: openGuide }, { children: [_jsx("img", { src: lampBulbPng, className: stepone.lamp, alt: "" }, void 0),
                                _jsx("div", Object.assign({ className: stepone.desc }, { children: "\u4EC0\u4E48\u67DC\u578B\u9002\u5408\u6211\u5BB6\uFF1F" }), void 0)] }), void 0),
                        _jsx("p", Object.assign({ className: stepone.cabinet_height }, { children: t('size_data.bottom_cabinet_shape') }), void 0),
                        _jsx(GroupRectCheckbox, { options: sizeList, defaultValue: initState.sizeUnder.key, onChange: (e) => changUnder(e), style: {
                                height: 5.5, fontSize: '12px', marginRight: 0.75, marginTop: 0.75,
                            } }, void 0),
                        _jsx("p", Object.assign({ className: stepone.cabinet_height }, { children: t('size_data.top_cabinet_shape') }), void 0),
                        _jsx(GroupRectCheckbox, { options: [...topTypeList(initState.sizeUnder.key), ...noTopSizeList], defaultValue: initState.sizeTop.key, onChange: (e) => changeTop(e), isTop: true, style: {
                                height: 5.5, fontSize: '12px', marginRight: 0.75, marginTop: 0.75,
                            } }, void 0)] }), void 0) }), void 0),
            _jsx(ShapeChooseGuide, { isShowMaterialMask: showGuide, closeMask: () => setShowGuide(false) }, void 0)] }, void 0));
}
